module.exports = __webpack_public_path__ + "img/1447189490.5a033953.jpg";